module.exports = __webpack_public_path__ + "static/media/mainimg-05.d11bf886.png";